import { ReactElement } from "react";
import { t } from "@lingui/macro";

import { EmptyState } from "components/placeholder/empty-state";
import PageContainer from "containers/page-container";
import errorImage from 'assets/error.png';

export default function LoadingErrorPage(): ReactElement {
  const onRefresh = () => {
    window.location.reload();
  }
  
  const firstButton: any = {
    label: t`Refresh`,
    onClick: onRefresh,
  }
  
  return (
    <PageContainer>
      <EmptyState
        title={t`Something went wrong`}
        illustration={errorImage}
        description={t`Refresh the page or contact support if the issue continues`}
        visible={true}
        firstButton={firstButton}
      />
    </PageContainer>
  )
}